import { object, string } from 'yup';

const schema = object({
    sourceType: string().required('Source Type is a required field'),
    sourceName: string().test({
        name: 'sourceName-required-if-direct',
        test(value, context) {
            const { sourceType } = this.parent;
            if (sourceType === 'direct' && !value) {
                return context.createError({
                    message: 'Source Name is a required field',
                });
            }
            return true;
        },
    }),

    referral: object().test({
        name: 'referral-required-if-referral',
        test(value, context) {
            const { sourceType } = this.parent;
            if (
                sourceType === 'referral' &&
                (!value || !Object.keys(value).length)
            ) {
                return context.createError({
                    message: 'Referral is a required field',
                });
            }
            return true;
        },
    }),
});

export default schema;
